module.exports = __webpack_public_path__ + "img/dcfl08.3f05fe63.png";